import { createStore, compose, applyMiddleware } from 'redux'
import reducers from 'reducers'
import promiseMiddleware from 'redux-promise-middleware'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const enhancer = composeEnhancers(applyMiddleware(
  promiseMiddleware()
))
const store = createStore(reducers, {}, enhancer)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js